import PropTypes from 'prop-types';
import React from 'react';
import TimelineContainer from 'common/timeline/containers/timeline-container';
import { useParams } from 'react-router';

const TechnicianTimeline = ({ renderMenu, ...rest }) => {
  const params = useParams();
  return <>
    <TimelineContainer
      id={rest?.id}
      jumpToDate={
        params.filtervalue ? null : params.jumpToDateOrFilter
      }
      activeFilter={
        params.filtervalue && params.jumpToDateOrFilter
      }
      activeFilterValue={params.filtervalue}
      type='technician'
      canCreateTicket={false}
      canCreateOrder={false}
      renderMenu={renderMenu}
      {...rest}
    />
  </>;
};
TechnicianTimeline.propTypes = {
  renderMenu: PropTypes.func.isRequired,
};

export default TechnicianTimeline;
